export default __webpack_public_path__ + "static/media/flip_up_new.eaff966a.png";